<template>
  <div class="sd-fold-card" :style="labelStyle_">
    <div class="card-switch__panel">
      <div class="switch-box__items-wrap" @mouseover="mouseChange(true)" @mouseout="mouseChange(false)">
        <div class="display-item fold" v-show="!mouseEnter_ && selectItem_">
          <div class="box-item">
            <img :src="selectItem_.displayImage" class="item-image" />
            <div class="item-name select">
              <span>{{ selectItem_.name }}</span>
            </div>
          </div>
        </div>
        <div class="box-items expended" v-show="mouseEnter_">
          <div
            class="box-item"
            v-for="item in data"
            :key="item.name"
            @mouseenter="mouseEnterItem(item.name)"
            @click="clickSelectItem(item)"
            :class="mouseEnterName_ === item.name ? 'mouse-enter' : 'mouse-leave'"
          >
            <img :src="item.displayImage" class="item-image" />
            <div class="item-name" :class="selectItem_.name === item.name ? 'select' : 'no-select'">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @description 卡片展示
 * @author GuoYun
 */
export default {
  name: 'SdFoldCards',
  data() {
    return {
      labelStyle_: {
        position: 'absolute',
        right: '0px',
        bottom: '0px',
        'z-index': 10,
      },
      mouseEnter_: false,
      mouseEnterName_: '',
      selectItem_: null,
    }
  },
  props: {
    customStyle: {
      type: Object,
      default() {
        return {}
      },
    },
    data: {
      type: Array,
      default() {
        return []
      },
    },
    defaultItem: {
      type: Object,
      default() {
        return null
      },
    },
  },
  created() {
    this.initParameter()
    this.selectItem_ = this.defaultItem ? this.defaultItem : this.data.length > 0 ? this.data[0] : null
  },
  methods: {
    initParameter() {
      this.labelStyle_ = Object.assign(this.labelStyle_, this.customStyle)
    },
    mouseChange(isEnter) {
      this.mouseEnter_ = isEnter
      if (!isEnter) {
        this.mouseEnterName_ = ''
      }
    },
    mouseEnterItem(name) {
      this.mouseEnterName_ = name
    },
    clickSelectItem(item) {
      this.selectItem_ = item
      this.$emit('click', item)
    },
  },
}
</script>

<style scoped>
@keyframes my-expended {
  from {
    width: 100px;
  }
  to {
    width: 320px;
  }
}
@keyframes my-fold {
  from {
    width: 130px;
  }
  to {
    width: 100px;
  }
}
.switch-box__items-wrap {
  display: inline-block;
  padding: 40px;
}

.expended {
  animation: my-expended 1s;
  animation-fill-mode: forwards;
}

.fold {
  animation: my-fold 0.2s;
  animation-fill-mode: forwards;
}
.display-item {
  left: 0px;
}
.box-items {
  width: 330px;
  overflow: hidden;
  display: flex;
  bottom: 0;
  left: 0;
  justify-content: left;
}
.box-item {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 5px;
}

.item-name {
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  width: 100%;
  bottom: 10px;
}
.item-image {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}
.mouse-enter {
  opacity: 100%;
  cursor: pointer;
}
.mouse-leave {
  opacity: 50%;
  padding-top: 5px;
}
.select {
  background: rgba(38, 38, 238, 0.5);
}
.no-select {
  background: rgba(0, 0, 0, 0.5);
}
</style>
